import React from 'react'

const CrossIcon = ({ size }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill="none" viewBox="0 0 24 24">
            <path fill="#000" d="M18.364 5.636a1 1 0 0 1 0 1.414L13.414 12l4.95 4.95a1 1 0 0 1-1.414 1.414L12 13.414l-4.95 4.95a1 1 0 1 1-1.414-1.414L10.586 12l-4.95-4.95A1 1 0 1 1 7.05 5.636L12 10.586l4.95-4.95a1 1 0 0 1 1.414 0z" />
        </svg>
    )
}

export default CrossIcon